import { NgModule } from '@angular/core';
import { RouterModule, Routes} from '@angular/router';


const APP_ROUTES: Routes = [
    { path: 'home',  loadChildren: './components/home/home.module#HomeModule'},
    { path: 'bienvenida/:id', loadChildren: './components/bienvenida/bienvenida.module#BienvenidaModule'},
    { path: 'recuperar-clave', loadChildren: './components/recuperar-pass/recuperar-pass.module#RecuperarPassModule'},
    { path: 'cambiar-clave', loadChildren: './components/change-pass/change-pass.module#ChangePassModule'},
    { path: '**', pathMatch: 'full', redirectTo: 'home'},
    //{ path: "cambiar-clave", pathMatch:"full", redirectTo: "cambiar-clave"},
    
];

@NgModule({
    imports: [
      RouterModule.forRoot(APP_ROUTES)
    ],
    exports: [
      RouterModule
    ],
    declarations: []
  })
  export class AppRoutingModule { }
//export const APP_ROUTING = RouterModule.forRoot(APP_ROUTES);
